var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4V20H18V4H8ZM7 2H19C19.28 2 19.5167 2.09667 19.71 2.29C19.9033 2.48333 20 2.72 20 3V21C20 21.28 19.9033 21.5167 19.71 21.71C19.5167 21.9033 19.28 22 19 22H7C6.72 22 6.48333 21.9033 6.29 21.71C6.09667 21.5167 6 21.28 6 21V3C6 2.72 6.09667 2.48333 6.29 2.29C6.48333 2.09667 6.72 2 7 2ZM13 17C13.28 17 13.5167 17.0967 13.71 17.29C13.9033 17.4833 14 17.72 14 18C14 18.28 13.9033 18.5167 13.71 18.71C13.5167 18.9033 13.28 19 13 19C12.72 19 12.4833 18.9033 12.29 18.71C12.0967 18.5167 12 18.28 12 18C12 17.72 12.0967 17.4833 12.29 17.29C12.4833 17.0967 12.72 17 13 17Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.6eea7c308e17d7a37655625fb6ee4fd9.svg";
export { ForwardRef as ReactComponent };